import { createFileRoute } from "@tanstack/react-router";

import MagicLinkVerifyPage from "@/features/auth/pages/magic-link-verify";
import { AuthProvider } from "@/providers/auth.provider";

interface MagicLinkVerifySearchParams {
  token?: string;
}

export const Route = createFileRoute("/(auth)/magic-link/verify")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Magic-link sign-in page" className="min-h-screen w-full">
        <MagicLinkVerifyPage />
      </main>
    </AuthProvider>
  ),
  validateSearch: (search: Record<string, unknown>): MagicLinkVerifySearchParams => ({
    token: search.token as string | undefined,
  }),
});
